module.exports = __webpack_public_path__ + "img/no-team-activity-percentage.44e25856.png";